import { render, staticRenderFns } from "./ticketAdminList.vue?vue&type=template&id=4a76f06a"
import script from "./ticketAdminList.vue?vue&type=script&lang=js"
export * from "./ticketAdminList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports